module.exports = __webpack_public_path__ + "img/icon_s-1.1.646e3350.svg";